<template>
  <div class="bg-white" :class="{'px-2': !VISAO_VERTICAL_ATIVA}">
    <portal to="portal-menu-principal-topbar" tag="div">
      <BarraDeMenuPrincipal class="ml-6" />
    </portal>

    <div :class="{'d-flex': VISAO_VERTICAL_ATIVA}" class="px-1 pt-3px pb-1" style="height: calc(100vh - 60px)">
      <ListaProdutos :class="CLASSES_CSS_LISTA_PRODUTOS" />
      <Detalhes :class="CLASSES_CSS_DETALHES" />
    </div>
  </div>
</template>

<script>
import BarraDeMenuPrincipal from "@/components/compra/ProdutosGerais/BarraDeMenuPrincipal";
import ListaProdutos from "@/components/compra/ProdutosGerais/ListaProdutos/Index.vue";
import Detalhes from "@/components/compra/ProdutosGerais/Detalhes.vue";

export default {
  name: "CompraPorProdutosGerais",
  components: {
    BarraDeMenuPrincipal,
    ListaProdutos,
    Detalhes,
  },
  computed: {
    VISAO_VERTICAL_ATIVA() {
      return this.$store.getters['CompraProdutosGerais/getVisaoVertical'];
    },
    CLASSES_CSS_LISTA_PRODUTOS() {
      return this.VISAO_VERTICAL_ATIVA ? 'lista-produtos-visao-vertical' : 'lista-produtos-visao-horizontal';
    },
    CLASSES_CSS_DETALHES() {
      return this.VISAO_VERTICAL_ATIVA ? 'detalhes-visao-vertical' : 'detalhes-visao-horizontal';
    }
  },
  created() {
    localStorage.analiseGrupoFornecedores = 'S';
  },
  destroyed() {
    localStorage.analiseGrupoFornecedores = 'N';
  }
}
</script>

<style scoped>
.lista-produtos-visao-vertical {
  width: 54%;
}
.detalhes-visao-vertical {
  width: 46%;
  height: 100%;
  margin-left: 7px;
}
.lista-produtos-visao-horizontal {
  position: absolute;
  margin-top: 335px;
  width: calc(100vw - 22px);
}
.detalhes-visao-horizontal {
  height: 326px;
}
</style>
